"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ramda_1 = require("ramda");
const publicodes_1 = require("publicodes");
const styled_components_1 = __importDefault(require("styled-components"));
const react_1 = require("react");
const contexts_1 = require("../contexts");
const cleanDomain = (link) => (link.includes('://') ? link.split('/')[2] : link.split('/')[0]).replace('www.', '');
// TODO: currently we only allow customizing the list of "references icons", but
// this migth be limited for more advanced usages. For instance futur.eco uses a
// different renderer for references:
// https://futur.eco/documentation/transport/avion/impact We will probably want
// to allow the user to provide its own components that can be inserted at
// certains positions in the generated documentation ("hooks").
function Ref({ name, link }) {
    const references = react_1.useContext(contexts_1.ReferencesImagesContext);
    const refKey = Object.keys(references).find((r) => link.includes(r));
    const domain = cleanDomain(link);
    return (jsx_runtime_1.jsxs("li", Object.assign({ style: {
            display: 'flex',
            alignItems: 'center',
        } }, { children: [jsx_runtime_1.jsx("span", Object.assign({ className: "imageWrapper" }, { children: refKey && jsx_runtime_1.jsx("img", { src: references[refKey] }, void 0) }), void 0), jsx_runtime_1.jsx("a", Object.assign({ href: link, target: "_blank", style: {
                    marginRight: '1rem',
                } }, { children: publicodes_1.capitalise0(name) }), void 0), jsx_runtime_1.jsx("span", Object.assign({ className: "ui__ label" }, { children: domain }), void 0)] }), name));
}
function References({ refs }) {
    const references = ramda_1.toPairs(refs);
    return (jsx_runtime_1.jsx(StyledComponent, { children: references.map(([name, link]) => (jsx_runtime_1.jsx(Ref, { name: name, link: link }, link))) }, void 0));
}
exports.default = References;
const StyledComponent = styled_components_1.default.ul `
	list-style: none;
	padding: 0;
	a {
		flex: 1;
		min-width: 45%;
		text-decoration: underline;
	}

	li {
		margin-bottom: 0.6em;
		width: 100%;
		display: flex;
		align-items: center;
	}
	.imageWrapper {
		width: 4.5rem;
		height: 3rem;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 1rem;
	}
	img {
		max-height: 3rem;
		vertical-align: sub;
		max-width: 100%;
		border-radius: 0.3em;
	}
`;
